import * as React from "react";
import { Outlet } from "react-router-dom";

function BaseLayout() {
    return (
        <Outlet/>
    );
}

export default BaseLayout;